<div class="introduction-feature-modal">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h3 class="modal-title">Check out our new features</h3>
    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body text-center">
    <div class="image-container">
      <img
        *ngIf="currentSlide.image"
        [src]="currentSlide.image"
        [alt]="currentSlide.imageAlt || 'Feature Image'"
        class="slide-image"
      />
    </div>

    <div class="slide-dots d-flex justify-content-center align-items-center" *ngIf="slides.length > 1">
      <span
        *ngFor="let slide of slides; let i = index"
        class="dot"
        [class.active]="i === currentSlideIndex"
        (click)="goToSlide(i)"
      ></span>
    </div>

    <div class="slide-info-container">
      <p class="slide-title-bold font-weight-bold">{{ currentSlide.title }}</p>
      <p class="slide-description">{{ currentSlide.description }}</p>
    </div>
  </div>

  <div class="flex justify-between item-center m-0 p-0" [style.justify-content]="slides.length > 1 ? 'space-between' : 'flex-end'">
    <button
      *ngIf="slides.length > 1"
      type="button"
      class="btn-back"
      [disabled]="currentSlideIndex === 0"
      (click)="back()"
    >
      Back
    </button>
    <button
      type="button"
      class="btn-next"
      (click)="next()"
    >
      {{ currentSlideIndex === slides.length - 1 ? 'Explore' : 'Next' }}
    </button>
  </div>
</div>
